// --- Config: set your Storefront token safely via Liquid ---
const STOREFRONT_TOKEN = window.FoxTheme?.settings?.storefrontAccessToken;

if (!STOREFRONT_TOKEN) {
    console.error('Storefront access token not found. Please add it to theme settings.');
}

async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
}

function toProductGID(numericId) {
    return `gid://shopify/Product/${numericId}`;
}

async function fetchForceSoldOutMap(productIdsNumeric) {
    if (!productIdsNumeric.length) return {};
    const ids = [...new Set(productIdsNumeric)].map(toProductGID);

    const query = `
    query($ids:[ID!]!) {
      nodes(ids:$ids) {
        ... on Product {
          id
          metafield(namespace:"custom", key:"force_sold_out") { value type }
        }
      }
    }`;

    const res = await fetch(`${window.shopUrl}/api/2025-01/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
            'Accept': 'application/json',
        },
        body: JSON.stringify({ query, variables: { ids } }),
    });

    if (!res.ok) return {};

    const json = await res.json();
    const map = {};
    for (const node of json.data?.nodes || []) {
        if (!node) continue;
        const numericId = node.id.split('/').pop();
        const raw = node.metafield?.value;
        // Metafield could be a boolean, string, or JSON depending on definition; treat "true" (case-insensitive) or true as true.
        const isForced = (raw === true) || (typeof raw === 'string' && raw.toLowerCase() === 'true');
        map[numericId] = isForced;
    }
    return map;
}

async function enforceForceSoldOut() {
    const cart = await getCart();
    if (!cart?.items?.length) return;

    // Get product IDs to check via API
    const productIds = [...new Set(cart.items.map((item) => item.product_id))];
    const forceSoldOutMap = await fetchForceSoldOutMap(productIds);

    const updates = {};
    let changed = false;

    for (const item of cart.items) {
        // Check if the product is force sold out via API
        const isForceSoldOut = forceSoldOutMap[item.product_id];

        if (isForceSoldOut) {
            updates[item.variant_id] = 0;
            changed = true;
        }
    }

    if (!changed) return;

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle },
        }),
    );

    try {
        const config = FoxTheme.utils.fetchConfig('javascript');
        config.body = JSON.stringify({
            updates,
            sections: sectionsToBundle,
            sections_url: window.location.pathname,
        });

        const response = await fetch(FoxTheme.routes.cart_update_url, config);
        const cartData = await response.json();

        // Publish cart update event like other cart operations
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: cartData,
            source: 'force-sold-out',
        });

        // Show notification to user
        if (window.FoxTheme?.notification) {
            const removedCount = Object.values(updates).filter((qty) => qty === 0).length;
            window.FoxTheme.notification.show(
                `${removedCount} item(s) removed from cart as they are no longer available.`,
                'warning',
            );
        }
    } catch (error) {
        console.error('Error updating cart for force sold out items:', error);
        // Fallback to page reload if cart update fails
        window.location.reload();
    }
}

// Run on cart/drawer loads and after any add-to-cart completes
document.addEventListener('DOMContentLoaded', enforceForceSoldOut);
// Listen for Shopify's cart update events
document.addEventListener('cart:updated', enforceForceSoldOut);
// Listen for theme's pubsub cart updates
if (window.FoxTheme?.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, enforceForceSoldOut);
}
